export default __webpack_public_path__ + "static/slide-4-5e144dd31bcffef5c966006aca87a271.png";